<template>
  <div id="wallet" class="tab-cnt" v-if="adsTransaction">
    <div class="wallet-box">
      <div class="wallet-amt">₹{{ adsTransaction.shoppingBalance }}</div>
      <div class="load-amt">
        <button class="button" @click="loadWallet">Load Wallet</button>
      </div>
    </div>

    <div class="wallet-history">
      <h2>Wallet History</h2>
      <ul v-if="adsTransaction.adsTransactionHistory.length">
        <li
          v-for="(item, index) in adsTransaction.adsTransactionHistory"
          :key="index"
        >
          <div class="info-text">
            <div class="item">
              <h3>{{ item.comment }}</h3>
              <!-- <span class="text-date">15 Jul 20, 15:32 PM</span> -->
            </div>
            <div class="item amt-val">₹{{ item.amount }}</div>
          </div>
        </li>
      </ul>
    </div>
     <Toaster :dataValue="toasterData" />
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { SessionHelper } from "../utils/session";
import constant from '../utils/constants'
import Toaster from "./Toaster";
export default {
  name: "WalletInfo",
  data() {
    return {
      toasterData: {},
    };
  },
  components:{
    Toaster
  },
  computed: {
    ...mapState(["adsTransaction", "ads"]),
  },
  mounted() {
    console.log("=", constant.CALLBACK_URL_COUPON);
  },
  methods: { 
    loadWallet(){
    console.log('=$cookies=', SessionHelper.getCookie("X-Auth-Id"), constant.CALLBACK_URL_COUPON)
     if(SessionHelper.getCookie("X-Auth-Id")){
         var callbackurl = null;
          SessionHelper.setCookie("loadWallet", "true");
          if (window.location.host.indexOf("localhost") != -1) {
            callbackurl = encodeURIComponent("http://localhost:8080/#/order-status");
          } else {
            callbackurl = encodeURIComponent(constant.CALLBACK_URL_COUPON);
          }
       window.location.href = `http://billsbe.payboard.in/load-db-wallet?encodedId=${SessionHelper.getCookie('X-Auth-Id')}&callbackUrl=${callbackurl}`
     }else{
      this.toasterData = {
          status: true,
          msg: 'Invalid Authentication',
          timeoutMs: "5000",
          color: "#ff6600",
        };
     }
    }
  },
};
</script>
